export const fieldDescriptionWrapperSelectorName =
	'jira-issue-field-description-field-description-wrapper';
export const FIELD_DESCRIPTION_WRAPPER_COMPONENT_SELECTOR =
	'[data-component-selector="jira-issue-field-description-field-description-wrapper"]';
